function NROpenWRTDark({ height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M11.9991 12.4411C11.2476 12.4411 10.64 13.0486 10.64 13.8002C10.64 14.5518 11.2476 15.1593 11.9991 15.1593C12.7507 15.1593 13.3583 14.5518 13.3583 13.8002C13.3583 13.0486 12.7507 12.4456 11.9991 12.4411Z"
        fill="white"
      />
      <path
        d="M3.65991 5.46084L5.07305 6.87399C6.84623 5.10081 9.29897 4.00721 11.9992 4.00721C14.6995 4.00721 17.1522 5.10081 18.9254 6.87399L20.3386 5.46084C18.2053 3.32763 15.2576 2 11.9992 2C8.74091 2 5.79312 3.32763 3.65991 5.46084Z"
        fill="white"
      />
      <path
        d="M6.21163 8.0126L7.62477 9.42573C8.74538 8.30512 10.298 7.61205 11.9992 7.61205C13.7004 7.61205 15.253 8.30512 16.3781 9.42573L17.7913 8.0126C16.3106 6.53195 14.2584 5.60035 12.0037 5.60035C9.74897 5.60035 7.69677 6.52745 6.21613 8.0126"
        fill="white"
      />
      <path
        d="M8.74533 10.5464L10.1585 11.9595C11.1756 10.9424 12.8227 10.9424 13.8443 11.9595L15.2575 10.5464C14.3934 9.68227 13.2233 9.20071 12.0036 9.20071C10.7435 9.20071 9.59141 9.71377 8.74983 10.5464"
        fill="white"
      />
      <path
        d="M17.0128 10.1593C17.7598 11.1854 18.2054 12.4456 18.2054 13.8002C18.2054 17.2205 15.4196 20.0063 11.9993 20.0063C8.57892 20.0063 5.79315 17.2205 5.79315 13.8002C5.79315 12.4411 6.23419 11.1809 6.98577 10.1593L5.55913 8.7327C4.45202 10.1323 3.79945 11.892 3.79945 13.8002C3.79945 18.3141 7.48532 22 11.9993 22C16.5132 22 20.1991 18.3141 20.1991 13.8002C20.1991 11.8875 19.533 10.1278 18.4394 8.7327L17.0128 10.1593Z"
        fill="#00B2E3"
      />
    </svg>
  );
}
export default NROpenWRTDark;
